import { generateClient } from 'aws-amplify/api';
import FormSelectInput from "./FormSelectInput";
import { listLocations } from "../common/graphql/queries";

const client = generateClient();

let runningPromise;
const FormSelectLocation = (props) => {
    const loadOptions = async (input) => {
        try {
            if (runningPromise) client.cancel(runningPromise);
            runningPromise = client.graphql({
                query: listLocations,
                variables: {},
            })

            const { data: { listLocations: { items } } } = await runningPromise;

            return items.map(cx => ({ value: cx.id, label: cx.name }))
        } catch (ex) {
            return []
        }
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectLocation;